
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/credits/add-credits",
      function () {
        return require("private-next-pages/credits/add-credits.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/credits/add-credits"])
      });
    }
  